const DEFAULT_IMAGES = {
  bank_logo: require('../../assets/images/icon_bank_logo.png'),
  send_money: require('../../assets/images/icon_send_money.png'),
  account_info: require('../../assets/images/icon_account_info.png'),
  request_payment: require('../../assets/images/icon_request_payment.png'),
  split_payment: require('../../assets/images/icon_split_payment.png'),
  top_up: require('../../assets/images/icon_top_up.png'),
  link_out: require('../../assets/images/icon_link_out.png'),
  pay_bills: require('../../assets/images/icon_loan.png'),
  loan: require('../../assets/images/icon_pay_bill.png'),
  verify_recipient_icon: require('../../assets/images/icon_search.png'),
  empty_state_icon: require('../../assets/images/icon_empty_state.png'),
  general_error_icon: require('../../assets/images/icon_general_error.png'),
  no_connection_icon: require('../../assets/images/icon_no_connection.png'),
  transaction_failed_icon: require('../../assets/images/icon_transaction_failed.png'),
  no_landscape_icon: require('../../assets/images/icon_no_landscape.png'),
  success_image: require('../../assets/images/success_image.png'),
  img_arrow_right_button: require('../../assets/images/img_arrow_right_button.png'),
  no_results_image: require('../../assets/images/icon_no_results.png'),
  keyboard_logo: require('../../assets/images/icon_square_keyboard_logo.png'),
  kbd_announcement_icon: require('../../assets/images/icon_announcement.png'),
  kbd_come_back_icon: require('../../assets/images/icon_kbd_come_back.png'),
  kbd_success_icon: require('../../assets/images/successOnboarding.png'),
  onboarding_small_stickers: require('../../assets/images/icon_stickers_small.png'),
  onboarding_big_stickers: require('../../assets/images/icon_stickers_big.png'),
  permission_to_photos_icon: require('../../assets/images/permission_to_photos.png'),
  iMsg_bank_logo: require('../../assets/images/icon_iMessage_logo.png'),
  company_logo: require('../../assets/images/company_logo.png'),
};

const getDefaultImageByKey = (imageKey) => DEFAULT_IMAGES[imageKey];

export const getImageByKey = (image, theKey) => (!image
|| !image.fUri
|| image.fUri.length === 0
  ? getDefaultImageByKey(theKey)
  : { uri: image.fUri });

export const getServiceImageByKey = (globJSON, subCategoryId, subCategory) => (globJSON.configurations.services[subCategoryId] === null
|| globJSON.configurations.services[subCategoryId].icon.fUri === null
|| globJSON.configurations.services[subCategoryId].icon.fUri.length === 0
  ? getDefaultImageByKey(subCategory)
  : { uri: globJSON.configurations.services[subCategoryId].icon.fUri });

export const getServiceActionBarImageByKey = (globJSON, subCategoryId, subCategory, icon_name) => (globJSON.configurations.services[subCategoryId] === null
    || globJSON.configurations.services[subCategoryId][icon_name].fUri === null
    || globJSON.configurations.services[subCategoryId][icon_name].fUri.length === 0
  ? getDefaultImageByKey(subCategory)
  : { uri: globJSON.configurations.services[subCategoryId][icon_name].fUri });

export const getSwitcherButtonImage = (value, alwaysOn, forceDisable) => {
  let img = value ? img_on : img_off;
  if (alwaysOn) img = img_always_on;
  if (forceDisable) img = img_always_off;
  return img;
};

// Panels;
export const img_success = require('../../assets/images/icon_success.png');
export const img_ios_screen_success = require('../../assets/images/scr_send_money_success.png');
export const img_android_screen_success = require('../../assets/images/and_scr_success.png');
export const img_ios_screen_chat = require('../../assets/images/scr_send_money_share_in_chat.png');
export const img_android_screen_chat = require('../../assets/images/and_scr_share_in_chat.png');
export const img_screen_paste_receipt_chat = require('../../assets/images/and_scr_paste_receipt_chat.png');
export const img_icon_add_circle = require('../../assets/images/icon_add_circle.png');
export const img_android_screen_simple_keypad = require('../../assets/images/and_scr_simple_num_kbd.png');
export const img_expand = require('../../assets/images/icon_point_right.png');
export const img_collapse = require('../../assets/images/icon_expand.png');
export const img_expanded = require('../../assets/images/icon_expanded.png');
export const img_attachment = require('../../assets/images/icon_attachment.png');
export const img_close_x = require('../../assets/images/icon_close_x.png');
export const img_arrange = require('../../assets/images/icon_arrange.png');
export const img_x = require('../../assets/images/icon_close_s.png');
export const img_dropdown = require('../../assets/images/icon_dropdown_small_black.png');
export const add_recipient = require('../../assets/images/add_recipient.png');

// MainScreen.js;
export const img_blue_down_arrow = require('../../assets/images/icon_blue_down_arrow.png');

// Panel_Z01_send_form.js;
export const img_download = require('../../assets/images/icon_download.png');
export const img_and_onboarding_enable_kbd = require('../../assets/images/and_onboarding_enable_kbd.png');
export const img_ios_1 = require('../../assets/images/snapshot_onboarding_ios_1_2.png');
export const img_ios_2 = require('../../assets/images/snapshot_onboarding_ios_2.png');
export const img_and_1 = require('../../assets/images/snapshot_onboarding_and_1.png');
export const img_sprites = require('../../assets/images/icon_stickers.png');
export const img_stickers_big = require('../../assets/images/icon_stickers_big.png');
export const img_stickers_small = require('../../assets/images/icon_stickers_small.png');
export const img_bank_shield_color = require('../../assets/images/bank-shield-color.png');
export const img_bank_shield_mask = require('../../assets/images/bank-shield-mask.png');
export const img_bank_stars = require('../../assets/images/bank-stars.png');
export const img_bank_stars_bg = require('../../assets/images/bank-stars-bg.png');
export const img_bank_main = require('../../assets/images/bank-bank-transparency-layer.png');
export const img_bank_main_bg = require('../../assets/images/bank-bank-cta.png');
export const img_bank_back = require('../../assets/images/bank-bank-font-cta-pressed.png');
export const img_bank_door = require('../../assets/images/bank-door-font-primary.png');
export const img_scr_2b_and = require('../../assets/images/and_scr_onboarding_02_b.png');
export const img_scr_status_Bar_Ios = require('../../assets/images/scr_onboarding_status_Bar_Ios.png');
export const img_scr_phoneFrame_Ios = require('../../assets/images/scr_phoneFrame_Ios.png');
export const img_chat_ios = require('../../assets/images/scr_onboarding_02_chat.png');
export const img_check = require('../../assets/images/icon_check.png');
export const chat_Bottom = require('../../assets/images/chatBottom.png');
export const chat_Top = require('../../assets/images/chatTop.png');

// Simulators;

// Sim_A03_Menu.js;
export const img_ios_qab_services = require('../../assets/images/qab_services_ios.png');
export const img_android_qab_services = require('../../assets/images/qab_services_android.png');

// Sim_B06_SendMoneyToAccountManually.js;
export const img_ios_screen_list_search = require('../../assets/images/scr_list_search.png');
export const img_android_screen_list_search = require('../../assets/images/and_scr_list_search.png');
export const img_android_back = require('../../assets/images/icon_arrow_left.png');
export const img_ios_back = require('../../assets/images/icon_back.png');
export const img_icon_search = require('../../assets/images/icon_search.png');
export const img_icon_search_x = require('../../assets/images/deleteContactPopup.png');

// Sim_B08_SendMoneyAmount.js;
export const img_ios_screen_simple_keyboard = require('../../assets/images/scr_simple_numeric_keypad.png');
export const img_go = require('../../assets/images/icon_go.png');

// Sim_B09_SendMoneyReference.js;
export const icon_gallery = require('../../assets/images/icon_gallery.png');
export const img_cake = require('../../assets/images/img_cake.png');
export const img_tree_with_sky = require('../../assets/images/img_tree_with_sky.png');
export const img_black_cat = require('../../assets/images/img_black_cat.png');
export const img_pizza = require('../../assets/images/img_pizza.png');
export const img_picture_collage = require('../../assets/images/img_picture_collage.png');

// Sim_B12_SendMoneySuccess.js;
export const img_android_screen_share_dialog = require('../../assets/images/and_scr_share_dialog.png');
export const img_screen_success_receipt = require('../../assets/images/scr_send_money_success_paste_reciept.png');
export const img_close = require('../../assets/images/icon_close_black.png');
export const img_typing_ios = require('../../assets/images/img_inputTextIos.png');

// Sim_C02_AccountInfoBalance.js;
export const img_bank_account = require('../../assets/images/icon_bank_account.png');
export const img_arrow_right = require('../../assets/images/icon_right_s.png');
export const img_e_wallet = require('../../assets/images/icon_e_wallet.png');
export const img_credit_card = require('../../assets/images/icon_credit_card.png');

// Sim_D01_PayBillsBillsList.js;
export const icon_bill = require('../../assets/images/icon_bill.png');
export const scan_barcode = require('../../assets/images/scan.png');
export const hand_type = require('../../assets/images/hand_type.png');
export const barcode_scan = require('../../assets/images/barcode.png');

// Sim_D04_PayBillsConfirmation.js;
export const img_ios_screen_date_picker = require('../../assets/images/scr_date_picker.png');
export const img_android_screen_date_picker = require('../../assets/images/and_scr_date_picker.png');

export const img_back = require('../../assets/images/icon_back.png');
export const img_ios_screen_launch = require('../../assets/images/scr_launch_ios.png');
export const img_android_screen_launch = require('../../assets/images/scr_launch_android.png');

// Sim_T02_Auth.js;
export const img_scr_numeric_1234 = require('../../assets/images/scr_simple_numeric_keypad_with_1234.png');
export const img_icon_pincode = require('../../assets/images/icon_pin_code.png');
export const img_icon_touch_id_ios = require('../../assets/images/icon_touch_id.png');
export const img_icon_touch_id_and = require('../../assets/images/and_icon_touch_id.png');
export const img_icon_face_id = require('../../assets/images/icon_face_id.png');

// Sim_T03_Launch_error_messages.js;
export const img_scr_landscape_ios = require('../../assets/images/scr_landscape.png');
export const img_scr_landscape_and = require('../../assets/images/and_scr_landscape.png');

// Sim_V01_announcement.js;
export const img_announcement = require('../../assets/images/icon_announcement.png');
export const img_scr_onboarding_01_ios = require('../../assets/images/scr_onboarding_01.png');
export const img_scr_onboarding_01_and = require('../../assets/images/and_scr_onboarding_01.png');

// Sim_X01_themeColors.js;
export const img_ios_screen_simple = require('../../assets/images/scr_simple.png');
export const img_android_screen_simple = require('../../assets/images/and_scr_simple.png');
export const img_drop_down_blue = require('../../assets/images/drop-down_blue.png');

// Sim_J03_LoanSelectSource.js;
export const img_credit_card_source = require('../../assets/images/credit_card.png');

// Sim_V03_instructions.js;
export const img_globe = require('../../assets/images/icon_globe.png');
export const img_emoji = require('../../assets/images/icon_emoji.png');
export const img_settings = require('../../assets/images/icon_onboarding_settings.png');
export const img_kbd = require('../../assets/images/icon_onboarding_kbd.png');
export const img_switch = require('../../assets/images/icon_onboarding_switch.png');
export const img_lock = require('../../assets/images/icon-onboarding-lock.png');
export const img_arrow = require('../../assets/images/icon_onboarding_arrow.png');
export const img_scr_onboarding_03_a_ios = require('../../assets/images/scr_onboarding_03_a.png');
export const img_scr_onboarding_03_a_and = require('../../assets/images/and_scr_onboarding_03_a.png');
export const scr_onboarding_dynamic_03_b = require('../../assets/images/scr_onboarding_dynamic_03_b.png');
export const img_scr_onboarding_03_c_ios = require('../../assets/images/scr_onboarding_03_c.png');
export const img_scr_onboarding_03_c_and = require('../../assets/images/and_scr_onboarding_03_c.png');
export const img_scr_ios_LightKeyboard = require('../../assets/images/scr_ios_LightKeyboard.png');
export const img_and_enable_kbd = require('../../assets/images/img_and_enable_kbd.png');
export const img_and_select_kbd = require('../../assets/images/img_and_select_kbd.png');

//= ========================================================================;

// MyUploadButton.js;
export const img_upload = require('../../assets/images/icon_upload.png');
export const img_subtitle = require('../../assets/images/icon_for_subtitle.png');
export const img_title = require('../../assets/images/icon_for_title.png');

// SideMenuItem.js;
export const img_theme_on = require('../../assets/images/icon_theme_on.png');
export const img_services_on = require('../../assets/images/icon_services_on.png');
export const img_interactions_on = require('../../assets/images/icon_interactions_on.png');
export const img_deliverables_on = require('../../assets/images/icon_deliverables_on.png');
export const img_onboarding_on = require('../../assets/images/img_onboarding_on.png');
export const img_keyboard_on = require('../../assets/images/img_keyboard_on.png');
export const img_send_on = require('../../assets/images/icon_send_on.png');
export const img_developer_on = require('../../assets/images/icon_development_on.png');

export const img_theme_off = require('../../assets/images/icon_theme_off.png');
export const img_services_off = require('../../assets/images/icon_services_off.png');
export const img_interactions_off = require('../../assets/images/icon_interactions_off.png');
export const img_deliverables_off = require('../../assets/images/icon_deliverables_off.png');
export const img_onboarding_off = require('../../assets/images/img_onboarding_off.png');
export const img_keyboard_off = require('../../assets/images/img_keyboard_off.png');
export const img_send_off = require('../../assets/images/icon_send_off.png');
export const img_developer_off = require('../../assets/images/icon_development_off.png');

// Utils.js;
export const textsDict = require('../../assets/tables/system_texts.json');

// MyShareTypeMenu.js;
export const img_check_black = require('../../assets/images/icon_check_black.png');

// MySwitch.js;
export const img_on = require('../../assets/images/switch_on.png');
export const img_off = require('../../assets/images/switch_off.png');
export const img_always_on = require('../../assets/images/switch_mandatory.png');
export const img_always_off = require('../../assets/images/switch_mandatory_off.png');

// ImagesManagementUtils.js;
export const img_arrow_up = require('../../assets/images/icon_arrow_up.png');
export const img_arrow_down = require('../../assets/images/icon_arrow_down.png');

// MyScreenLine.js;
export const img_arrange_black = require('../../assets/images/icon_arrange_black.png');
export const img_point_right_black = require('../../assets/images/icon_point_right_black.png');
export const img_expand_black = require('../../assets/images/icon_expand_black.png');
export const img_add = require('../../assets/images/icon_add.png');
export const img_close_black = require('../../assets/images/icon_close_black.png');
export const img_hide = require('../../assets/images/icon_hide.png');

// AdminScreen.js;
export const img_paykey = require('../../assets/images/paykey.png');

// Sim_V02_promotion.js;
export const img_scr_2a_ios = require('../../assets/images/scr_onboarding_02_a.png');
export const img_scr_logo_ios = require('../../assets/images/scr_onboarding_logo_ios.png');
export const img_scr_2a_and = require('../../assets/images/and_scr_onboarding_02_a.png');
export const img_scr_logo_android = require('../../assets/images/scr_onboarding_logo_android.png');

// DuplicateConfigurations.js
export const img_duplication_add = require('../../assets/images/icon-add.png');
export const img_duplication_delete = require('../../assets/images/ic-delete.png');

// Onboarding
export const img_onboarding_and_02_a = require('../../assets/images/snapshot_onboarding_and_02_a.png');
export const img_onboarding_ios_02_a = require('../../assets/images/snapshot_onboarding_ios_02_a.png');

// Keyboard
export const img_action_bar_page_ios = require('../../assets/images/img_action_bar_page_ios.png');
export const img_action_bar_android = require('../../assets/images/img_action_bar_android.png');
export const promotion_carousel_page = require('../../assets/images/promotion_carousel_page.png');
export const clean_full_page_ios = require('../../assets/images/clean_full_page_ios.png');
export const img_message_bar_android = require('../../assets/images/img_message_bar_android.png');
export const img_promotion_1 = require('../../assets/images/img_promotion_1.png');
export const img_promotion_2 = require('../../assets/images/img_promotion_2.png');
export const icon_promotion = require('../../assets/images/icon_promotion.png');

// imessage
export const img_imsg_toolbar = require('../../assets/images/imsg_toolbar.png');
export const img_imsg_text_field = require('../../assets/images/img_imsg_text_field.png');
export const img_imsg_scr = require('../../assets/images/imsg_img_scr.png');

// Request Payment
export const scr_success_request = require('../../assets/images/scr_success_request.png');
export const img_receipt = require('../../assets/images/receipt.png');
export const img_receipt_bottom = require('../../assets/images/receipt_bottom.png');

// Split Payment
export const img_arrow_right_button = require('../../assets/images/img_arrow_right_button.png');
export const scr_success = require('../../assets/images/scr_success.png');

// Panel_Z01_send_form.js
export const img_send_button_create = require('../../assets/images/send_button_create_background.png');
export const img_send_button_publish_background = require('../../assets/images/send_button_publish_background.png');
export const img_send_button_setting_background = require('../../assets/images/send_button_setting_background.png');
export const img_send_button_setting = require('../../assets/images/send_button_setting.png');
